export const AIR_RETRIEVAL_MODE = {
  MANUAL_ENTRY: 'manual-entry',
  FLIGHT: 'flight',
  AIRPORT_ROUTE: 'airport-route',
};
